module.exports = __webpack_public_path__ + "assets/img/tag.bcff9ca7.svg";